<div class="ws-popup-header">
  <span>{{ title | translate }}</span>
  <div class="actions">
    <button mat-icon-button (click)="closeClicked()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="ws-popup-content">
  <div class="ws-popup-body">
    <!-- Date selection fields - first block -->
    <div class="customCalendarButtons">
      <form [formGroup]="dateToUse">
        <div class="field-combo">
          <div class="field-wrapper date-input">
            <label for="startDate">{{'Start date' | translate}}</label>
            <div (click)="startPicker.open()">
              <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
              <input id="startDate" [matDatepicker]="startPicker" formControlName="start"
                [ngClass]="{'input-error': dateToUse.get('end')?.invalid}" readonly />
            </div>

          </div>

          <div class="field-wrapper date-input">
            <label for="endDate">{{'End date' | translate}}</label>
            <div (click)="endPicker.open()">
              <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
              <input id="endDate" [matDatepicker]="endPicker" formControlName="end" [ngClass]="{'input-error': dateToUse.hasError('dateRangeInvalid') && 
                    (dateToUse.get('end')?.touched || dateToUse.get('end')?.dirty)}" readonly />
            </div>

          </div>
        </div>
      </form>
    </div>

    <!-- Time selection fields - second block -->
    <div>
      <form [formGroup]="dateToUse">
        <div class="field-combo">
          <div class="field-wrapper time-input">
            <label for="startTime">{{'Start Time' | translate}}</label>
            <div>
              <input id="startTime" type="time" formControlName="startTime"
                [ngClass]="{'input-error': dateToUse.get('startTime')?.invalid}" />
            </div>
          </div>

          <div class="field-wrapper time-input">
            <label for="endTime">{{'End Time' | translate}}</label>
            <div>
              <input id="endTime" type="time" formControlName="endTime"
                [ngClass]="{'input-error': dateToUse.get('endTime')?.invalid}" />
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Experience selection field - third block (single) -->
    <div class="field-wrapper">
      <label for="experienceId">{{'Experience name (Optional)' | translate}}</label>
      <input id="experienceId" (input)="filterExperiences()" [(ngModel)]="selectedReservation"
        [formControl]="experienceIdForm" [matAutocomplete]="auto" type="text" />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayReservation">
        <mat-option *ngFor="let experience of filteredOptions" [value]="experience">
          {{ displayReservation(experience) }}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="ws-popup-footer">
    <div></div>
    <ws-button (click)="exportPDFClicked()" [callToActionType]="'primary'">
      {{ "Print" | translate }}
    </ws-button>
  </div>
</div>

<reservation-pdf-exporter #exporterPDFPop></reservation-pdf-exporter>